import { DESKTOP_WIDTH } from '@/constants';

export interface GlobalState {
  isSidebarOpen: boolean;
}

export const initialState: GlobalState = {
  isSidebarOpen: window.innerWidth > DESKTOP_WIDTH,
};
